var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.typedText),function(char,index){return _c('span',{key:index},[_vm._v(_vm._s(char))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }